import Vue from 'vue'
import VModal from 'vue-js-modal'
Vue.use(VModal, { dynamic: true, injectModalsContainer: true })
/**
 * https://github.com/euvl/vue-js-modal
 */